export interface ISendVerificationCode {
  phoneNumber: string;
  userId: string;
  code: string;
}
